import React, {useEffect} from 'react';
import './experience.css'
import Tecnologies from './Tecnologies';
import AOS from 'aos'
import 'aos/dist/aos.css';

const Experience = () => {
  useEffect(() => {
    AOS.init({duration: 800})
  }, []);
  return (
    <section id='experince'>
        <h4 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="100">The Skills i Have</h4>
        <h2 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="200">My Experience</h2>
      <div className="container experience-container" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="300">
        <Tecnologies/>
      </div>
    </section>
  );
}

export default Experience;
